/** Maximum number of tag suggestions to display */
export const TAG_INPUT_MAX_SUGGESTIONS = 5;

/** Delay before processing blur event (allows click events to fire first) */
export const TAG_INPUT_BLUR_DELAY_MS = 200;
